import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress, Box, Grid, Button, Typography, Switch, TextField, makeStyles } from '@material-ui/core';
import { useFormik } from 'formik';

import { getConfiguracoesDoNegocio, updateConfiguracoesDoNegocio } from '../../store/actions/negocio';
import TituloPagina from '../../components/layout/TituloPagina';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const useStyles = makeStyles({
    root: {
        '& .MuiOutlinedInput-input': {
            textAlign: 'center',
            padding: '10px',
        },
    },
});

const ConfiguracoesDoNegocio = props => {
    const { getConfiguracoesDoNegocio, updateConfiguracoesDoNegocio, configuracoesDoNegocio, negocioDoUsuario, loading } = props;
    const classes = useStyles();
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingMessage, setProcessingMessage] = useState('');

    useEffect(() => {
        if (negocioDoUsuario) {
            getConfiguracoesDoNegocio(negocioDoUsuario);
        }
    }, [negocioDoUsuario, getConfiguracoesDoNegocio]);

    const formik = useFormik({
        initialValues: {
            id: configuracoesDoNegocio?.id ?? '',
            aplicarDescontoPix: configuracoesDoNegocio?.aplicarDescontoPix ?? false,
            atacadoSortido: configuracoesDoNegocio?.atacadoSortido ?? false,
            quantidadeMinimaAtacado: configuracoesDoNegocio?.quantidadeMinimaAtacado ?? '',
            negocioId: configuracoesDoNegocio?.negocioId ?? negocioDoUsuario
        },
        onSubmit: (values) => {

            setProcessingMessage('Salvando...');
            setIsProcessing(true);

            updateConfiguracoesDoNegocio(values);

            setIsProcessing(false);
            setProcessingMessage('');
        },
        enableReinitialize: true,
    });

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Configurações do Negócio' subtitulo={new Date().toLocaleString('pt-BR')} />

            <Box sx={{ height: '70vh' }}>
                <form onSubmit={formik.handleSubmit} noValidate autoComplete='off' style={{ width: 'inherit' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box bgcolor="secondary.main" color="white" p={2}>
                                <Grid item xs>
                                    <Typography variant='h6' component='p'>
                                        Vamos vender mais com o PIX?
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box bgcolor="background.paper" color="text.primary" p={2}>
                                <Grid container>
                                    <Grid item xs={10}>
                                        <p>Que tal dar aquele incentivo especial para seu cliente fechar a compra na hora? Com o nosso programa de desconto no PIX, seu cliente ganha 6% de desconto e o seu produto fica muito mais atrativo. E o melhor: nós dividimos essa conta com você!</p>
                                        <p>Funciona assim: Tiramos 3% da nossa comissão e você contribui com os outros 3%. No final, seu cliente fica feliz com o desconto e você garante a venda com o dinheiro caindo na conta em muito menos tempo!</p>
                                    </Grid>
                                    <Grid item xs={2} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Switch
                                            checked={formik.values.aplicarDescontoPix}
                                            onChange={formik.handleChange}
                                            name="aplicarDescontoPix"
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Box bgcolor="secondary.main" color="white" p={2}>
                                <Grid item xs>
                                    <Typography variant='h6' component='p'>
                                        Atacado sortido?
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box bgcolor="background.paper" color="text.primary" p={2}>
                                <Grid container>
                                    <Grid item xs={10}>
                                        <p>Ao ativar a opção de atacado sortido, o sistema passa a considerar qualquer produto da sua vitrine para a contagem e acionamento do preço de Atacado.</p>
                                    </Grid>
                                    <Grid item xs={2} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Switch
                                            checked={formik.values.atacadoSortido}
                                            onChange={formik.handleChange}
                                            name="atacadoSortido"
                                        />
                                    </Grid>
                                    {
                                        formik.values.atacadoSortido
                                            ?
                                            <>
                                                <Grid item xs={10}>
                                                    <p>Informe no campo ao lado a quantidade mínima de itens que deverá ser considerada para acionar o preço de Atacado. Essa informação terá prioridade em relação ao valor informado no cadastro do produto.</p>
                                                </Grid>
                                                <Grid item xs={2} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <TextField
                                                        id='quantidadeMinimaAtacado'
                                                        name='quantidadeMinimaAtacado'
                                                        variant='outlined'
                                                        className={classes.root}
                                                        placeholder='0'
                                                        value={formik.values.quantidadeMinimaAtacado}
                                                        onChange={formik.handleChange}
                                                    />
                                                </Grid>
                                            </>
                                            :
                                            null
                                    }
                                </Grid>
                            </Box>
                        </Grid>

                    </Grid>
                    <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                        <Grid item style={{ paddingRight: '15px' }}>
                            <Button color='primary' variant='contained' type='submit'>Salvar Configurações</Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={isProcessing}
                message={processingMessage}
            />
        </>
    )
}

const mapStateToProps = state => (
    {
        negocio: state.negocio.negocio,
        loading: state.negocio.loading,
        negocioDoUsuario: state.negocio.negocioDoUsuario,
        configuracoesDoNegocio: state.negocio.configuracoesDoNegocio,
    }
);

const mapDispatchToProps = dispatch => bindActionCreators({ getConfiguracoesDoNegocio, updateConfiguracoesDoNegocio }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracoesDoNegocio);